<template>
  <div class="third">
    <component :is="componentsName" :ref="componentsName" @todetail="todetail" :enterData="enterData"></component>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import BasicPage from "./components/basicPage";
import detail from "./components/detail";
export default {
    name: 'funcSuggestion',
    data() {
        return {
            enterData: '',
        }
    },
    computed: {
        ...mapState({
            componentsName: state => state.robotsManage.robotsManage_funcSuggestion_ComponentName,
        })
    },
    components: {
        BasicPage,
        detail
    },
    created() {
    },
    destroyed() {
        this.changeComponentName("BasicPage");
    },
    methods: {
        ...mapMutations({
            'changeComponentName': 'SET_robotsManage_funcSuggestion_ComponentName',
        }),
        todetail(val) {
            this.changeComponentName("detail");
            this.enterData = val
        },
    },
}
</script>
